export default "__VITE_ASSET__Coz_ycPz__"